import React from 'react';
import './SirenOverlay.css';

function SirenOverlay() {
  return (
    <>
      <div className="siren-overlay red-overlay" />
      <div className="siren-overlay blue-overlay" />
    </>
  );
}

export default SirenOverlay;
